// // Code review - In Progress
// // Documentation - In Progress
// import React, { useEffect, useState } from "react";
// import { mainTable } from "../css/Common";
// import { BindAPI, BindPostAPI } from "../services/APIConnection";
// import InputText from "../ReusableComponents/InputText";
// import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
// import UsePrevious from "../Hook/UsePrevious";
// import { useUserCapability } from "../components/ConstantReducerProvider";

// const IssueOfCommodity = ({
//   isOpen,
//   data1,
//   currentData1,
//   currentData2,
//   issuePopupCancel,
//   updateScreenTitle,
// }) => {

//   const { userProfileState } = useUserCapability();
//   const userProfileDatas = userProfileState.userProfile;
//   const [bindCommodityDD, setBindCommodityDD] = useState([]);
//   const [bindCommodityTypeDD, setBindCommodityTypeDD] = useState([]);
//   const [bindCommodityNameDD, setBindCommodityNameDD] = useState([]);
//   const [bindBrandDD, setBindBrandDD] = useState([]);

//   const [medicineCommodityError, setMedicineCommodityError] = useState("");
//   const [servicesIssueDetails, setServicesIssueDetails] = useState([]);

//   const handleInputChange = (selectedOption, rowIndex, columnName) => {
//     const value = selectedOption ? selectedOption.value : "";
//     setTableData((prevTableData) => {
//       const updatedData = [...prevTableData];
//       updatedData[rowIndex] = { ...updatedData[rowIndex], [columnName]: value };
//       convertArrayToJSONString(updatedData);
//       return updatedData;
//     });
//   };
//   const convertArrayToJSONString = (array) => {
//     try {
//       const jsonString = JSON.stringify(array);
//       setServicesIssueDetails(jsonString);
//       return jsonString;
//     } catch (error) {
//       return null;
//     }
//   };

//   const headerData = [
//     {
//       title: "Commodity",
//       key: "commoditiesCategoryType",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Commodity Category",
//       key: "commoditiesCategory",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Commodity Name",
//       key: "commoditiesName",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Brand",
//       key: "commoditiesBrand",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Qty.",
//       key: "commoditiesQty",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "U.O.M.",
//       key: "commoditiesUOM",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Charges",
//       key: "charges",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//     {
//       title: "Action",
//       key: "Action",
//       width: "md:w-80 2xl:w-96 truncate  px-2 py-3 m-auto",
//     },
//   ];

//   const [tableData, setTableData] = useState([
//     {
//       commodity: "",
//       commodityCategory: "",
//       commodityName: "",
//       brand: "",
//       quantity: "",
//       uom: "",
//       charges: "",
//       commodityCategoryList: [],
//       commodityNameList: [],
//       brandList: [],
//       currentStock: "",
//     },
//   ]);

//   const getEmptyCommodityRow = () => ({
//     commodity: "",
//     commodityCategory: "",
//     commodityName: "",
//     brand: "",
//     quantity: "",
//     uom: "",
//     charges: "",
//     commodityCategoryList: [],
//     commodityNameList: [],
//     brandList: [],
//     currentStock: "",
//   });


//   const handleDeleteRow = (index) => {
//     setTableData((prevData) => {
//       const updatedTableData = prevData.filter((_, i) => i !== index);

//       // Ensure at least one row exists
//       if (updatedTableData.length === 0) {
//         const newRow = {
//           commodity: "",
//           commodityCategory: "",
//           commodityName: "",
//           brand: "",
//           quantity: "",
//           uom: "",
//           charges: "",
//           commodityCategoryList: [],
//           commodityNameList: [],
//           brandList: [],
//           currentStock: "",
//         };

//         // Use spread to create a new array
//         return [newRow];
//       }

//       convertArrayToJSONString(updatedTableData); // Call convertArrayToJSONString
//       return updatedTableData;
//     });
//   };
//   const handleAddRow = () => {
//     const newRow = { ...tableData[tableData.length - 1] }; // Copy the last row
//     newRow.commodity = "";
//     newRow.commodityCategory = ""; // Clear the values of the new row
//     newRow.commodityName = "";
//     newRow.quantity = "";
//     newRow.uom = "";
//     newRow.charges = "";
//     newRow.commodityCategoryList = [];
//     newRow.commodityNameList = [];
//     newRow.brandList = [];
//     newRow.currentStock = "";

//     setTableData((prevData) => [...prevData, newRow]); // Add the new row to the table data
//   };

//   useEffect(() => {
//     const commodityTypeDD = async () => {
//       try {
//         const data = {

//           languageCode: "en",
//         };
//         const commodityTypeResponse = await BindPostAPI([data], "CommoditiesAPI/GetCommoditiesCategory");

//         const commodityResponse = await BindPostAPI([data], "InventoryReceiptAPI/BindCommodityType");

//         const brandResponse = await BindPostAPI([data], "BrandAPI/BindBrand");



//         const commodityResponseData = commodityResponse.data.Table.filter(
//           (item) =>
//             item.MstCommodityTypeId === 2 || item.MstCommodityTypeId === 3
//         ).map((item) => ({
//           value: item.MstCommodityTypeId,
//           label: item.CommodityType_en,
//         }));

//         setBindBrandDD(brandResponse.data.Table);

//         setBindCommodityDD(commodityResponseData);
//         setBindCommodityTypeDD(commodityTypeResponse.data.Table);
//       } catch (error) {
//         // Handle API call errors (e.g., show an error message)
//       }
//     };

//     const commodityNameDD = async () => {
//       try {
//         const data = {

//           languageCode: "en",
//         };
//         const commodityNameResponse = await BindPostAPI([data], "CommoditiesAPI/BindCommodities");

//         // setBindCommodityDD(commodityNameResponse.data.Table);

//         setBindCommodityNameDD(commodityNameResponse.data.Table);
//       } catch (error) {
//         // Handle API call errors (e.g., show an error message)
//       }
//     };

//     commodityTypeDD();
//     commodityNameDD();
//   }, []);

//   const handleSubmit = () => {
//     if (servicesIssueDetails.length === 0) {
//       setMedicineCommodityError("Fill the above table");
//     } else {
//       let medicineCommodityData = [];
//       try {
//         medicineCommodityData = JSON.parse(servicesIssueDetails);
//       } catch (error) {
//         setMedicineCommodityError("Error parsing Medicine Commodity data");
//         return; // Exit the function early if there's an error
//       }

//       if (!Array.isArray(medicineCommodityData)) {
//         setMedicineCommodityError("Medicine Commodity data is not an array");
//         return; // Exit the function early if data is not an array
//       }

//       const medicineCommodityErrors = medicineCommodityData.map(
//         (medicineCommodity) => {
//           if (
//             !medicineCommodity ||
//             !medicineCommodity.commodity ||
//             !medicineCommodity.commodityCategory ||
//             !medicineCommodity.commodityName ||
//             !medicineCommodity.brand ||
//             !medicineCommodity.quantity ||
//             !medicineCommodity.uom ||
//             !medicineCommodity.charges
//           ) {
//             return "Medicine Commodity information is incomplete";
//           }
//           return null;
//         }
//       );

//       const hasMedicineCommodityErrors = medicineCommodityErrors.some(
//         (error) => error !== null
//       );

//       if (!hasMedicineCommodityErrors) {
//         setMedicineCommodityError("");
//         const data2 = servicesIssueDetails;
//         data1(data2);
//         isOpen(false);
//       } else {
//         setMedicineCommodityError(
//           "Please provide complete Medicine Commodity information"
//         );
//       }
//     }
//   };

//   const previousTableData = UsePrevious(tableData);

//   // Only track fields that actually require re-deriving dropdown lists or
//   // refetching stock. Quantity/UOM/Charges must NOT be part of this signature —
//   // otherwise every keystroke re-triggers the stock API call, and the async
//   // response can land after further keystrokes and overwrite what you just
//   // typed. That's the "glitch" while typing Qty.
//   const commodityKeyFields = tableData.map((row) => ({
//     commodity: row.commodity,
//     commodityCategory: row.commodityCategory,
//     commodityName: row.commodityName,
//     brand: row.brand,
//   }));
//   const commodityKeySignature = JSON.stringify(commodityKeyFields);
//   const previousCommodityKeySignature = UsePrevious(commodityKeySignature);

//   useEffect(() => {
//     const updateTableData = async () => {
//       // if (previousCommodityKeySignature === commodityKeySignature) {
//       //   return; // nothing relevant changed — skip, don't touch quantity/charges
//       // }

//       const updatedTableData = await Promise.all(
//         tableData.map(async (row) => {
//           const updatedRow = { ...row };

//           if (row?.commodity) {
//             const getFilteredCategory = bindCommodityTypeDD
//               .filter((item) => item.MstCommodityTypeId == row.commodity)
//               .map((items) => ({
//                 value: items.MstCommodityCategoryId,
//                 label: items.CommodityCategory_en,
//               }));
//             updatedRow.commodityCategoryList = getFilteredCategory;
//           }

//           if (row?.commodityCategory) {
//             const selectedCommoditiesCategory = bindCommodityNameDD
//               .filter((item) => item.MstCommodityCategoryId == row.commodityCategory)
//               .map((item) => ({
//                 value: item.MstCommoditiesId,
//                 label: item.CommodityName_en,
//                 uom: item.CommodityUOM,
//               }));
//             updatedRow.commodityNameList = selectedCommoditiesCategory;

//             const selectedCommodity = selectedCommoditiesCategory.find(
//               (item) => item.value === row.commodityName
//             );
//             updatedRow.uom = selectedCommodity ? selectedCommodity.uom : "";
//           }

//           if (row?.commodityName) {
//             const selectedBrandCategory = bindBrandDD
//               .filter((item) => item.MstCommoditiesId == row.commodityName)
//               .map((items) => ({
//                 value: items.MstBrandId,
//                 label: items.Brand_en,
//               }));
//             updatedRow.brandList = selectedBrandCategory;
//           }

//           if (row?.brand) {
//             const data = {
//               mstCommodityType: row.commodity,
//               mstCategoryId: row.commodityCategory,
//               mstCommodityId: row.commodityName,
//               mstBrandId: row.brand,
//               mstOrganizationStructureId: userProfileDatas[0].MstOrganizationId,
//               mstUserId: userProfileDatas[0].MstUserId,
//               mstRoleId: userProfileDatas[0].MstRoleId,
//               mstBranchProjectId: userProfileDatas[0].MstLocationId,
//               mstSDPId: currentData2[0] ? currentData2[0] : 0,
//               mstAreaId: currentData2[1] ? currentData2[1] : 0,
//               mstORWId:
//                 userProfileDatas[0].MstRoleId == 7
//                   ? userProfileDatas[0].MstUserId
//                   : 0,
//               servicesId: currentData2[2] ? currentData2[2] : "",
//               flag: 1,
//             };

//             try {
//               const response = await BindPostAPI(
//                 [data],
//                 "TXNServicesAPI/BindAvailableCurrentStock"
//               );
//               if (response?.data?.Table?.length > 0) {
//                 updatedRow.currentStock = response.data.Table[0].BalanceQuantity ?? "";
//               } else {
//                 updatedRow.currentStock = "";
//               }
//             } catch (error) {
//               updatedRow.currentStock = "";
//             }
//           }

//           return updatedRow;
//         })
//       );

//       // Merge into the LATEST state (functional update) so any quantity/charges
//       // keystrokes typed while the stock call was in flight are preserved,
//       // instead of being clobbered by the stale snapshot in updatedTableData.
//       setTableData((latest) =>
//         latest.map((latestRow, idx) => ({
//           ...updatedTableData[idx],
//           quantity: latestRow.quantity,
//           charges: latestRow.charges,
//         }))
//       );
//     };

//     updateTableData();
//   }, [commodityKeySignature,currentData1, currentData2, bindCommodityTypeDD, bindCommodityNameDD, bindBrandDD]);

//   // useEffect(() => {

//   //   const updateTableData = async () => {
//   //     if (JSON.stringify(previousTableData) !== JSON.stringify(tableData)) {
//   //       const updatedTableData = await Promise.all(
//   //         tableData.map(async (row, rowIndex) => {
//   //           const updatedRow = { ...row }; // Avoid direct mutation

//   //           if (row?.commodity) {
//   //             const getFilteredCategory = bindCommodityTypeDD
//   //               .filter((item) => item.MstCommodityTypeId == row.commodity)
//   //               .map((items) => ({
//   //                 value: items.MstCommodityCategoryId,
//   //                 label: items.CommodityCategory_en,
//   //               }));
//   //             updatedRow.commodityCategoryList = getFilteredCategory;
//   //           }

//   //           if (row?.commodityCategory) {
//   //             const selectedCommoditiesCategory = bindCommodityNameDD
//   //               .filter(
//   //                 (item) => item.MstCommodityCategoryId == row.commodityCategory
//   //               )
//   //               .map((item) => ({
//   //                 value: item.MstCommoditiesId,
//   //                 label: item.CommodityName_en,
//   //                 uom: item.CommodityUOM,
//   //               }));
//   //             updatedRow.commodityNameList = selectedCommoditiesCategory;

//   //             const selectedCommodity = selectedCommoditiesCategory.find(
//   //               (item) => item.value === row.commodityName
//   //             );

//   //             updatedRow.uom = selectedCommodity ? selectedCommodity.uom : "";
//   //           }

//   //           if (row?.commodityName) {
//   //             const selectedBrandCategory = bindBrandDD
//   //               .filter((item) => item.MstCommoditiesId == row.commodityName)
//   //               .map((items) => ({
//   //                 value: items.MstBrandId,
//   //                 label: items.Brand_en,
//   //               }));
//   //             updatedRow.brandList = selectedBrandCategory;
//   //           }

//   //           if (row?.brand) {

//   //             const data = {
//   //               mstCommodityType: row.commodity,
//   //               mstCategoryId: row.commodityCategory,
//   //               mstCommodityId: row.commodityName,
//   //               mstBrandId: row.brand,
//   //               mstOrganizationStructureId:
//   //                 userProfileDatas[0].MstOrganizationId,
//   //               mstUserId: userProfileDatas[0].MstUserId,
//   //               mstRoleId: userProfileDatas[0].MstRoleId,
//   //               mstBranchProjectId: userProfileDatas[0].MstLocationId,
//   //               mstSDPId: currentData2[0] ? currentData2[0] : 0,
//   //               mstAreaId: currentData2[1] ? currentData2[1] : 0,
//   //               mstORWId:
//   //                 userProfileDatas[0].MstRoleId == 7
//   //                   ? userProfileDatas[0].MstUserId
//   //                   : 0,
//   //               servicesId: currentData2[2] ? currentData2[2] : "",
//   //               flag: 1,
//   //             };

//   //             try {
//   //               const response = await BindPostAPI(
//   //                 [data],
//   //                 "TXNServicesAPI/BindAvailableCurrentStock"
//   //               );

//   //               if (response?.data?.Table?.length > 0) {
//   //                 const balanceQuantity =
//   //                   response.data.Table[0].BalanceQuantity ?? "";
//   //                 updatedRow.currentStock = balanceQuantity;
//   //               } else {
//   //                 updatedRow.currentStock = "";
//   //               }
//   //             } catch (error) {
//   //               updatedRow.currentStock = "";
//   //             }
//   //           }

//   //           return updatedRow;
//   //         })
//   //       );

//   //       setTableData(updatedTableData);
//   //     }
//   //   };

//   //   updateTableData();
//   // }, [tableData, currentData2, bindCommodityTypeDD, bindCommodityNameDD, bindBrandDD]);

//   useEffect(() => {
//     // When View/Edit data is available, load it into the table
//     if (Array.isArray(currentData1) && currentData1.length > 0) {
//       const formattedDataArray = currentData1.map((data) => ({
//         commodity: data.MstCommodityTypeId || "",
//         commodityCategory: data.MstCommodityCategoryId || "",
//         commodityName: data.MstCommodityId || "",
//         brand: data.MstBrandId || "",
//         quantity: data.Quantity || "",
//         uom: data.UOM || "",
//         charges: data.Charges || "",
//         commodityCategoryList: [],
//         commodityNameList: [],
//         brandList: [],
//         currentStock: "",
//       }));

//       setTableData(formattedDataArray);
//       convertArrayToJSONString(formattedDataArray);
//       setMedicineCommodityError("");
//     } else {
//       // currentData1 is empty => clear old View/Edit values
//       const emptyRow = {
//         commodity: "",
//         commodityCategory: "",
//         commodityName: "",
//         brand: "",
//         quantity: "",
//         uom: "",
//         charges: "",
//         commodityCategoryList: [],
//         commodityNameList: [],
//         brandList: [],
//         currentStock: "",
//       };

//       setTableData([emptyRow]);
//       setServicesIssueDetails("");
//       setMedicineCommodityError("");
//     }
//   }, [currentData1]);

//   useEffect(() => {
//     if (!Array.isArray(currentData1)) {
//       return;
//     }

//     // Edit/View has data
//     if (currentData1.length > 0) {
//       const formattedDataArray = currentData1.map((data) => ({
//         commodity: data.MstCommodityTypeId ?? "",
//         commodityCategory: data.MstCommodityCategoryId ?? "",
//         commodityName: data.MstCommodityId ?? "",
//         brand: data.MstBrandId ?? "",
//         quantity: data.Quantity ?? "",
//         uom: data.UOM ?? "",
//         charges: data.Charges ?? "",
//         commodityCategoryList: [],
//         commodityNameList: [],
//         brandList: [],
//         currentStock: "",
//       }));

//       setTableData(formattedDataArray);
//       setServicesIssueDetails(JSON.stringify(formattedDataArray));
//       setMedicineCommodityError("");
//     } else {
//       // New record / cleared data
//       const emptyRow = getEmptyCommodityRow();

//       setTableData([emptyRow]);
//       setServicesIssueDetails("");
//       setMedicineCommodityError("");
//     }
//   }, [currentData1]);


//   // Clear popup values only when cancel signal changes
//   useEffect(() => {
//     if (!issuePopupCancel) {
//       return;
//     }

//     const emptyRow = getEmptyCommodityRow();

//     setTableData([emptyRow]);
//     setServicesIssueDetails("");
//     setMedicineCommodityError("");
//   }, [issuePopupCancel]);



//   return (
//     <div class="w-full">
//       <div class={mainTable.mainContentScreen}>
//         <form class={mainTable.formForPopup}>
//           <div class={mainTable.labelBold}>Medicine / Commodities</div>
//           <hr class={mainTable.servicesHorizontalLine}></hr>
//           <div className="hidden md:block">
//             <table className="w-full border border-gray-300 mt-6">
//               <thead>
//                 <tr>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Commodity
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Commodity Category
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Commodity Name
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Brand
//                   </th>

//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Qty.
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     U.O.M.
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 p-2">
//                     Charges
//                   </th>
//                   <th className="border text-white bg-[#2d2d6e] border-gray-300 ">
//                     Action
//                   </th>
//                 </tr>
//               </thead>
//               <tbody>
//                 {tableData.map((row, index) => (
//                   <tr key={index}>
//                     <td className="border border-gray-300 p-2 w-48">
//                       <AutoDropDown
//                         Class="Custom-class"
//                         options={bindCommodityDD}
//                         disabled={updateScreenTitle}
//                         placeholder="Select"
//                         name="commodity"
//                         selectedOption={
//                           row.commodity
//                             ? bindCommodityDD.find(
//                               (x) => x.value == row.commodity
//                             )
//                             : ""
//                         }
//                         controlFunc={(e) => {
//                           handleInputChange(e, index, "commodity");
//                         }}
//                       />
//                     </td>
//                     <td className="border border-gray-300 p-2 w-52">
//                       <AutoDropDown
//                         Class="Custom-class"
//                         options={row.commodityCategoryList || []}
//                         placeholder="Select"
//                         disabled={updateScreenTitle}
//                         name="commodityCategory"
//                         selectedOption={
//                           row.commodityCategory
//                             ? row.commodityCategoryList
//                               ? row.commodityCategoryList.find(
//                                 (x) => x.value === row.commodityCategory
//                               )
//                               : null
//                             : ""
//                         }
//                         controlFunc={(selectedOption) => {
//                           handleInputChange(
//                             selectedOption,
//                             index,
//                             "commodityCategory"
//                           );
//                         }}
//                       />
//                     </td>
//                     <td className="border border-gray-300 p-2 w-44">
//                       <AutoDropDown
//                         Class="Custom-class"
//                         options={row.commodityNameList || []}
//                         placeholder="Select"
//                         name="productName"
//                         disabled={updateScreenTitle}
//                         selectedOption={
//                           row.commodityName
//                             ? row.commodityNameList
//                               ? row.commodityNameList.find(
//                                 (x) => x.value === row.commodityName
//                               )
//                               : null
//                             : ""
//                         }
//                         controlFunc={(selectedOption) => {
//                           handleInputChange(
//                             selectedOption,
//                             index,
//                             "commodityName"
//                           );
//                         }}
//                       />
//                     </td>
//                     <td className="border border-gray-300 p-2 w-40">
//                       <AutoDropDown
//                         Class="Custom-class"
//                         options={row.brandList || []}
//                         placeholder="Select"
//                         name="brand"
//                         disabled={updateScreenTitle}
//                         selectedOption={
//                           row.brand
//                             ? row.brandList
//                               ? row.brandList.find((x) => x.value === row.brand)
//                               : null
//                             : ""
//                         }
//                         controlFunc={(selectedOption) => {
//                           handleInputChange(selectedOption, index, "brand");
//                         }}
//                       />
//                     </td>

//                     <td className="border border-gray-300 p-2 w-20">
//                       <div title={`Available Stock: ${row.currentStock || 0}`}>
//                         <InputText
//                           type="text"
//                           content={row.quantity}
//                           maxLength={5}
//                           controlFunc={(e) => {
//                             const InputText = e.target.value;

//                             if (
//                               /^[0-9]*$/.test(InputText) &&
//                               (InputText === "" ||
//                                 parseFloat(InputText) <=
//                                 (row.currentStock || 0))
//                             ) {
//                               handleInputChange(e.target, index, "quantity");
//                             }
//                           }}
//                         />
//                       </div>
//                     </td>

//                     <td className="border border-gray-300 p-2 cursor-not-allowed w-16">
//                       <InputText
//                         type="text"
//                         content={row.uom}
//                         disabled={true}
//                         maxLength={10}
//                         controlFunc={(e) => {
//                           const InputText = e.target.value;

//                           if (/^[A-Za-z]*$/.test(InputText)) {
//                             handleInputChange(e.target, index, "uom");
//                           }
//                         }}
//                       />
//                     </td>
//                     <td className="border border-gray-300 p-1 w-20 font-normal">
//                       <InputText
//                         type="text"
//                         content={row.charges}
//                         maxLength={11}
//                         controlFunc={(e) => {
//                           const InputText = e.target.value;

//                           if (/^\d*\.?\d*$/.test(InputText)) {
//                             handleInputChange(e.target, index, "charges");
//                           }
//                         }}
//                       />
//                     </td>
//                     <td className="border border-gray-300 w-16">
//                       <div className="flex gap-4 align-baseline items-center justify-center">
//                         <svg
//                           viewBox="0 0 20 20"
//                           fill="currentColor"
//                           className={`${updateScreenTitle ? "w-6 h-6 cursor-not-allowed opacity-50" : "w-6 h-6 text-black cursor-pointer"}`}
//                           onClick={() => !updateScreenTitle && handleDeleteRow(index)}
//                         >
//                           <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
//                         </svg>
//                         <svg
//                           viewBox="0 0 1024 1024"
//                           fill="currentColor"
//                           onClick={() => !updateScreenTitle && handleAddRow()}
//                           // class="w-6 h-6 text-black cursor-pointer"
//                           className={`${updateScreenTitle ? "w-6 h-6 cursor-not-allowed opacity-50" : "w-6 h-6 text-black cursor-pointer"}`}

//                         >
//                           <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
//                         </svg>
//                       </div>
//                     </td>
//                   </tr>
//                 ))}
//               </tbody>
//             </table>
//           </div>
//           <div className="hidden md:block">
//             {medicineCommodityError && (
//               <div className="text-red-500">{medicineCommodityError}</div>
//             )}
//           </div>
//           <div className={mainTable.tableMobile} role="table">
//             <div className="w-full md:overflow-y-auto lg:h-96 h-full">
//               {tableData.length > 0 &&
//                 tableData.map((row, index) => (
//                   <div scope="col" class={mainTable.mobileTable}>
//                     {headerData.map((keyData) => (
//                       <div scope="cell" class={mainTable.tableData} role="cell">
//                         {keyData.key === "Action" ? (
//                           <div class={mainTable.tableData}>
//                             <div className="md:block hidden">
//                               <button
//                                 id="dropdownMenuIconButton"
//                                 data-dropdown-toggle="dropdownDots"
//                                 class="inline-flex items-center text-sm font-medium text-center text-gray-900 bg-white rounded-lg hover:bg-gray-100 focus:ring-4 focus:outline-none dark:text-white focus:ring-gray-50 dark:bg-gray-800 dark:hover:bg-gray-700 dark:focus:ring-gray-600"
//                                 type="button"
//                               >
//                                 <svg
//                                   class="w-6 h-6"
//                                   aria-hidden="true"
//                                   fill="currentColor"
//                                   viewBox="0 0 20 20"
//                                   xmlns="http://www.w3.org/2000/svg"
//                                 >
//                                   <path d="M10 6a2 2 0 110-4 2 2 0 010 4zM10 12a2 2 0 110-4 2 2 0 010 4zM10 18a2 2 0 110-4 2 2 0 010 4z"></path>
//                                 </svg>
//                               </button>
//                             </div>
//                             <div className="md:hidden flex justify-center">
//                               <input
//                                 type="button"
//                                 className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
//                                 onClick={() => !updateScreenTitle && handleAddRow()}

//                                 value="Add"
//                               />
//                               <input
//                                 type="button"
//                                 className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
//                                 onClick={() => !updateScreenTitle && handleDeleteRow(index)}
//                                 value="Delete"
//                               />
//                             </div>
//                           </div>
//                         ) : keyData.key === "commoditiesCategoryType" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full font-bold">
//                               {keyData.title}
//                             </div>
//                             <AutoDropDown
//                               Class="Custom-class"
//                               options={bindCommodityDD}
//                               placeholder="Select"
//                               name="commodity"
//                               selectedOption={bindCommodityDD.find(
//                                 (x) => x.value == row.commodity
//                               )}
//                               controlFunc={(e) => {
//                                 handleInputChange(e, index, "commodity");
//                               }}
//                             />
//                           </div>
//                         ) : keyData.key === "commoditiesCategory" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full font-bold">
//                               {keyData.title}
//                             </div>
//                             <AutoDropDown
//                               Class="Custom-class"
//                               options={row.commodityCategoryList || []}
//                               placeholder="Select"
//                               name="commodityCategory"
//                               selectedOption={
//                                 row.commodityCategoryList
//                                   ? row.commodityCategoryList.find(
//                                     (x) => x.value === row.commodityCategory
//                                   )
//                                   : null
//                               }
//                               controlFunc={(selectedOption) => {
//                                 handleInputChange(
//                                   selectedOption,
//                                   index,
//                                   "commodityCategory"
//                                 );
//                               }}
//                             />
//                           </div>
//                         ) : keyData.key === "commoditiesName" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full font-bold">
//                               {keyData.title}
//                             </div>
//                             <AutoDropDown
//                               Class="Custom-class"
//                               options={row.commodityNameList || []}
//                               placeholder="Select"
//                               name="productName"
//                               selectedOption={
//                                 row.commodityNameList
//                                   ? row.commodityNameList.find(
//                                     (x) => x.value === row.commodityName
//                                   )
//                                   : null
//                               }
//                               controlFunc={(selectedOption) => {
//                                 handleInputChange(
//                                   selectedOption,
//                                   index,
//                                   "commodityName"
//                                 );
//                               }}
//                             />
//                           </div>
//                         ) : keyData.key === "commoditiesBrand" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full font-bold">
//                               {keyData.title}
//                             </div>
//                             <AutoDropDown
//                               Class="Custom-class"
//                               options={row.brandList || []}
//                               placeholder="Select"
//                               name="brand"
//                               selectedOption={
//                                 row.brandList
//                                   ? row.brandList.find(
//                                     (x) => x.value === row.brand
//                                   )
//                                   : null
//                               }
//                               controlFunc={(selectedOption) => {
//                                 handleInputChange(
//                                   selectedOption,
//                                   index,
//                                   "brand"
//                                 );
//                               }}
//                             />
//                           </div>
//                         ) : keyData.key === "commoditiesQty" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full whitespace-nowrap font-bold">
//                               {keyData.title}
//                             </div>
//                             <div
//                               title={`Available Stock: ${row.currentStock || 0
//                                 }`}
//                             >
//                               <InputText
//                                 type="text"
//                                 content={row.quantity}
//                                 controlFunc={(e) => {
//                                   const InputText = e.target.value;

//                                   if (
//                                     /^[0-9]*$/.test(InputText) &&
//                                     (InputText === "" ||
//                                       parseFloat(InputText) <=
//                                       (row.currentStock || 0))
//                                   ) {
//                                     handleInputChange(
//                                       e.target,
//                                       index,
//                                       "quantity"
//                                     );
//                                   }
//                                 }}
//                               />
//                             </div>
//                           </div>
//                         ) : keyData.key === "commoditiesUOM" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full whitespace-nowrap font-bold">
//                               {keyData.title}
//                             </div>
//                             <InputText
//                               type="text"
//                               content={row.uom}
//                               maxLength={10}
//                               controlFunc={(e) => {
//                                 const InputText = e.target.value;

//                                 if (/^[A-Za-z/s]*$/.test(InputText)) {
//                                   handleInputChange(e.target, index, "uom");
//                                 }
//                               }}
//                             />
//                           </div>
//                         ) : keyData.key === "charges" ? (
//                           <div className=" border p-1">
//                             <div className="flex items-center w-full whitespace-nowrap font-bold">
//                               {keyData.title}
//                             </div>
//                             <InputText
//                               type="text"
//                               content={row.charges}
//                               maxLength={11}
//                               controlFunc={(e) => {
//                                 const InputText = e.target.value;

//                                 if (/^\d*\.?\d*$/.test(InputText)) {
//                                   handleInputChange(e.target, index, "charges");
//                                 }
//                               }}
//                             />
//                           </div>
//                         ) : (
//                           <div className="flex border p-1">
//                             <div className="flex basis-1/2 font-bold">
//                               {keyData.title}
//                             </div>
//                           </div>
//                         )}
//                       </div>
//                     ))}
//                   </div>
//                 ))}
//             </div>
//           </div>
//           <div className="md:hidden">
//             {medicineCommodityError && (
//               <div className="text-red-500">{medicineCommodityError}</div>
//             )}
//           </div>
//           <div className={mainTable.submitCancelMainDiv}>
//             <button
//               data-modal-hide="bottom-right-modal"
//               type="button"
//               className={mainTable.submitButton}
//               onClick={() => handleSubmit()}
//             >
//               Submit
//             </button>
//           </div>
//         </form>
//       </div>
//     </div>
//   );
// };

// export default IssueOfCommodity;

import React, { useEffect, useRef, useState } from "react";
import { mainTable } from "../css/Common";
import { BindPostAPI } from "../services/APIConnection";
import InputText from "../ReusableComponents/InputText";
import AutoDropDown from "../ReusableComponents/AutoCompleteDropDown";
import { useUserCapability } from "../components/ConstantReducerProvider";

const getEmptyCommodityRow = () => ({
  commodity: "",
  commodityCategory: "",
  commodityName: "",
  brand: "",
  quantity: "",
  uom: "",
  charges: "",
  commodityCategoryList: [],
  commodityNameList: [],
  brandList: [],
  currentStock: "",
});

const headerData = [
  { title: "Commodity", key: "commoditiesCategoryType" },
  { title: "Commodity Category", key: "commoditiesCategory" },
  { title: "Commodity Name", key: "commoditiesName" },
  { title: "Brand", key: "commoditiesBrand" },
  { title: "Qty.", key: "commoditiesQty" },
  { title: "U.O.M.", key: "commoditiesUOM" },
  { title: "Charges", key: "charges" },
  { title: "Action", key: "Action" },
];

const IssueOfCommodity = ({
  isOpen,
  data1,
  currentData1,
  currentData2,
  issuePopupCancel,
  updateScreenTitle,
}) => {
  
  const { userProfileState } = useUserCapability();
  const userProfileDatas = userProfileState.userProfile;

  const [bindCommodityDD, setBindCommodityDD] = useState([]);
  const [bindCommodityTypeDD, setBindCommodityTypeDD] = useState([]);
  const [bindCommodityNameDD, setBindCommodityNameDD] = useState([]);
  const [bindBrandDD, setBindBrandDD] = useState([]);
  const [medicineCommodityError, setMedicineCommodityError] = useState("");
  const [tableData, setTableData] = useState([getEmptyCommodityRow()]);

  /* ---------------- row handlers ---------------- */

  const handleInputChange = (selectedOption, rowIndex, columnName) => {
    const value = selectedOption ? selectedOption.value : "";
    setTableData((prev) =>
      prev.map((row, i) => {
        if (i !== rowIndex) return row;
        const updated = { ...row, [columnName]: value };
        // Changing a parent dropdown invalidates everything below it
        if (columnName === "commodity") {
          Object.assign(updated, {
            commodityCategory: "",
            commodityName: "",
            brand: "",
            uom: "",
            currentStock: "",
          });
        } else if (columnName === "commodityCategory") {
          Object.assign(updated, {
            commodityName: "",
            brand: "",
            uom: "",
            currentStock: "",
          });
        } else if (columnName === "commodityName") {
          Object.assign(updated, { brand: "", currentStock: "" });
        } else if (columnName === "brand") {
          updated.currentStock = "";
        }
        return updated;
      })
    );
  };

  const handleDeleteRow = (index) => {
    setTableData((prev) => {
      const next = prev.filter((_, i) => i !== index);
      return next.length === 0 ? [getEmptyCommodityRow()] : next;
    });
  };

  const handleAddRow = () => {
    setTableData((prev) => [...prev, getEmptyCommodityRow()]);
  };

  const handleQtyChange = (e, index, row) => {
    const value = e.target.value;
    if (
      /^[0-9]*$/.test(value) &&
      (value === "" || parseFloat(value) <= (Number(row.currentStock) || 0))
    ) {
      handleInputChange(e.target, index, "quantity");
    }
  };

  const handleChargesChange = (e, index) => {
    if (/^\d*\.?\d*$/.test(e.target.value)) {
      handleInputChange(e.target, index, "charges");
    }
  };

  /* ---------------- master data (once) ---------------- */

  useEffect(() => {
    const loadMasters = async () => {
      const data = { languageCode: "en" };
      try {
        const [categoryRes, typeRes, brandRes, nameRes] = await Promise.all([
          BindPostAPI([data], "CommoditiesAPI/GetCommoditiesCategory"),
          BindPostAPI([data], "InventoryReceiptAPI/BindCommodityType"),
          BindPostAPI([data], "BrandAPI/BindBrand"),
          BindPostAPI([data], "CommoditiesAPI/BindCommodities"),
        ]);

        setBindCommodityDD(
          typeRes.data.Table.filter(
            (item) =>
              item.MstCommodityTypeId === 2 || item.MstCommodityTypeId === 3
          ).map((item) => ({
            value: item.MstCommodityTypeId,
            label: item.CommodityType_en,
          }))
        );
        setBindCommodityTypeDD(categoryRes.data.Table);
        setBindBrandDD(brandRes.data.Table);
        setBindCommodityNameDD(nameRes.data.Table);
      } catch (error) {
        // Handle API call errors (e.g., show an error message)
      }
    };
    loadMasters();
  }, []);

  /* ---------------- submit ---------------- */

  const handleSubmit = () => {
    // Build the payload from tableData (the source of truth), dropping UI-only fields
    const payload = tableData.map(
      ({
        commodityCategoryList,
        commodityNameList,
        brandList,
        currentStock,
        ...rest
      }) => rest
    );

    const incomplete = payload.some(
      (r) =>
        !r.commodity ||
        !r.commodityCategory ||
        !r.commodityName ||
        !r.brand ||
        !r.quantity ||
        !r.uom ||
        !r.charges
    );

    if (incomplete) {
      setMedicineCommodityError(
        "Please provide complete Medicine Commodity information"
      );
      return;
    }

    setMedicineCommodityError("");
    data1(JSON.stringify(payload));
    isOpen(false);
  };

  /* ---------------- derived lists + stock ---------------- */

  // Only these fields should trigger re-deriving lists / refetching stock.
  // Quantity and charges must NOT be here, or every keystroke refetches stock.
  const commodityKeySignature = JSON.stringify(
    tableData.map((row) => ({
      commodity: row.commodity,
      commodityCategory: row.commodityCategory,
      commodityName: row.commodityName,
      brand: row.brand,
    }))
  );

  useEffect(() => {
    let cancelled = false;

    const updateTableData = async () => {
      const derived = await Promise.all(
        tableData.map(async (row) => {
          const d = {
            commodityCategoryList: [],
            commodityNameList: [],
            brandList: [],
            uom: row.uom,
            currentStock: "",
          };

          if (row.commodity) {
            d.commodityCategoryList = bindCommodityTypeDD
              .filter((item) => item.MstCommodityTypeId == row.commodity)
              .map((item) => ({
                value: item.MstCommodityCategoryId,
                label: item.CommodityCategory_en,
              }));
          }

          if (row.commodityCategory) {
            d.commodityNameList = bindCommodityNameDD
              .filter(
                (item) => item.MstCommodityCategoryId == row.commodityCategory
              )
              .map((item) => ({
                value: item.MstCommoditiesId,
                label: item.CommodityName_en,
                uom: item.CommodityUOM,
              }));

            const selected = d.commodityNameList.find(
              (item) => item.value == row.commodityName
            );
            d.uom = selected ? selected.uom : "";
          }

          if (row.commodityName) {
            d.brandList = bindBrandDD
              .filter((item) => item.MstCommoditiesId == row.commodityName)
              .map((item) => ({
                value: item.MstBrandId,
                label: item.Brand_en,
              }));
          }

          if (row.brand) {
            const profile = userProfileDatas[0];
            const payload = {
              mstCommodityType: row.commodity,
              mstCategoryId: row.commodityCategory,
              mstCommodityId: row.commodityName,
              mstBrandId: row.brand,
              mstOrganizationStructureId: profile.MstOrganizationId,
              mstUserId: profile.MstUserId,
              mstRoleId: profile.MstRoleId,
              mstBranchProjectId: profile.MstLocationId,
              mstSDPId: currentData2?.[0] ? currentData2[0] : 0,
              mstAreaId: currentData2?.[1] ? currentData2[1] : 0,
              mstORWId: profile.MstRoleId == 7 ? profile.MstUserId : 0,
              servicesId: currentData2?.[2] ? currentData2[2] : "",
              flag: 1,
            };

            try {
              const response = await BindPostAPI(
                [payload],
                "TXNServicesAPI/BindAvailableCurrentStock"
              );
              d.currentStock =
                response?.data?.Table?.[0]?.BalanceQuantity ?? "";
            } catch (error) {
              d.currentStock = "";
            }
          }

          return d;
        })
      );

      if (cancelled) return; // a newer run replaced this one

      // Merge ONLY derived fields into the latest state. Everything the user
      // typed or selected (including rows just loaded from currentData1)
      // is preserved, so a late response can't overwrite it.
      setTableData((latest) =>
        latest.map((row, idx) => (derived[idx] ? { ...row, ...derived[idx] } : row))
      );
    };

    updateTableData();
    return () => {
      cancelled = true;
    };
    // tableData is intentionally read via the signature, not as a dependency
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    commodityKeySignature,
    currentData2,
    bindCommodityTypeDD,
    bindCommodityNameDD,
    bindBrandDD,
  ]);

  /* ---------------- load rows from parent ---------------- */

  // Single effect (the duplicate was removed). Runs on mount, so a popup that
  // remounts is repopulated from currentData1.
  useEffect(() => {
    if (Array.isArray(currentData1) && currentData1.length > 0) {
      setTableData(
        currentData1.map((data) => ({
          ...getEmptyCommodityRow(),
          commodity: data.MstCommodityTypeId ?? "",
          commodityCategory: data.MstCommodityCategoryId ?? "",
          commodityName: data.MstCommodityId ?? "",
          brand: data.MstBrandId ?? "",
          quantity: data.Quantity ?? "",
          uom: data.UOM ?? "",
          charges: data.Charges ?? "",
        }))
      );
    } else {
      setTableData([getEmptyCommodityRow()]);
    }
    setMedicineCommodityError("");
  }, [currentData1]);

  /* ---------------- cancel signal ---------------- */

  // Skip the initial mount so a stale `true` can never wipe data on open
  const cancelMounted = useRef(false);
  useEffect(() => {
    if (!cancelMounted.current) {
      cancelMounted.current = true;
      return;
    }
    if (!issuePopupCancel) return;

    setTableData([getEmptyCommodityRow()]);
    setMedicineCommodityError("");
  }, [issuePopupCancel]);

  /* ---------------- shared field renderers ---------------- */

  const renderDropdown = (row, index, field, options, name) => {
    const list = options || [];
    return (
      <AutoDropDown
        Class="Custom-class"
        options={list}
        placeholder="Select"
        name={name}
        disabled={updateScreenTitle}
        selectedOption={
          row[field] ? list.find((x) => x.value == row[field]) : ""
        }
        controlFunc={(selectedOption) =>
          handleInputChange(selectedOption, index, field)
        }
      />
    );
  };

  const renderQty = (row, index, maxLength) => (
    <div title={`Available Stock: ${row.currentStock || 0}`}>
      <InputText
        type="text"
        content={row.quantity}
        maxLength={maxLength}
        controlFunc={(e) => handleQtyChange(e, index, row)}
      />
    </div>
  );

  const renderUom = (row) => (
    <InputText
      type="text"
      content={row.uom}
      disabled={true}
      maxLength={10}
      controlFunc={() => { }}
    />
  );

  const renderCharges = (row, index) => (
    <InputText
      type="text"
      content={row.charges}
      maxLength={11}
      controlFunc={(e) => handleChargesChange(e, index)}
    />
  );

  const actionIconClass = updateScreenTitle
    ? "w-6 h-6 cursor-not-allowed opacity-50"
    : "w-6 h-6 text-black cursor-pointer";

  /* ---------------- render ---------------- */

  return (
    <div className="w-full">
      <div className={mainTable.mainContentScreen}>
        <form className={mainTable.formForPopup}>
          <div className={mainTable.labelBold}>Medicine / Commodities</div>
          <hr className={mainTable.servicesHorizontalLine}></hr>

          {/* Desktop table */}
          <div className="hidden md:block">
            <table className="w-full border border-gray-300 mt-6">
              <thead>
                <tr>
                  {headerData.map((h) => (
                    <th
                      key={h.key}
                      className="border text-white bg-[#2d2d6e] border-gray-300 p-2"
                    >
                      {h.title}
                    </th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {tableData.map((row, index) => (
                  <tr key={index}>
                    <td className="border border-gray-300 p-2 w-48">
                      {renderDropdown(row, index, "commodity", bindCommodityDD, "commodity")}
                    </td>
                    <td className="border border-gray-300 p-2 w-52">
                      {renderDropdown(row, index, "commodityCategory", row.commodityCategoryList, "commodityCategory")}
                    </td>
                    <td className="border border-gray-300 p-2 w-44">
                      {renderDropdown(row, index, "commodityName", row.commodityNameList, "productName")}
                    </td>
                    <td className="border border-gray-300 p-2 w-40">
                      {renderDropdown(row, index, "brand", row.brandList, "brand")}
                    </td>
                    <td className="border border-gray-300 p-2 w-20">
                      {renderQty(row, index, 5)}
                    </td>
                    <td className="border border-gray-300 p-2 cursor-not-allowed w-16">
                      {renderUom(row)}
                    </td>
                    <td className="border border-gray-300 p-1 w-20 font-normal">
                      {renderCharges(row, index)}
                    </td>
                    <td className="border border-gray-300 w-16">
                      <div className="flex gap-4 align-baseline items-center justify-center">
                        <svg
                          viewBox="0 0 20 20"
                          fill="currentColor"
                          className={actionIconClass}
                          onClick={() => !updateScreenTitle && handleDeleteRow(index)}
                        >
                          <path d="M6 2l2-2h4l2 2h4v2H2V2h4zM3 6h14l-1 14H4L3 6zm5 2v10h1V8H8zm3 0v10h1V8h-1z" />
                        </svg>
                        <svg
                          viewBox="0 0 1024 1024"
                          fill="currentColor"
                          className={actionIconClass}
                          onClick={() => !updateScreenTitle && handleAddRow()}
                        >
                          <path d="M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z" />
                        </svg>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
          <div className="hidden md:block">
            {medicineCommodityError && (
              <div className="text-red-500">{medicineCommodityError}</div>
            )}
          </div>

          {/* Mobile cards */}
          <div className={mainTable.tableMobile} role="table">
            <div className="w-full md:overflow-y-auto lg:h-96 h-full">
              {tableData.map((row, index) => (
                <div key={index} className={mainTable.mobileTable}>
                  {headerData.map((keyData) => (
                    <div key={keyData.key} className={mainTable.tableData} role="cell">
                      {keyData.key === "Action" ? (
                        <div className="md:hidden flex justify-center">
                          <input
                            type="button"
                            className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                            onClick={() => !updateScreenTitle && handleAddRow()}
                            value="Add"
                          />
                          <input
                            type="button"
                            className="bg-[#2d2d6e] text-white mr-1 py-1 px-2 rounded-lg"
                            onClick={() => !updateScreenTitle && handleDeleteRow(index)}
                            value="Delete"
                          />
                        </div>
                      ) : (
                        <div className="border p-1">
                          <div className="flex items-center w-full whitespace-nowrap font-bold">
                            {keyData.title}
                          </div>
                          {keyData.key === "commoditiesCategoryType" &&
                            renderDropdown(row, index, "commodity", bindCommodityDD, "commodity")}
                          {keyData.key === "commoditiesCategory" &&
                            renderDropdown(row, index, "commodityCategory", row.commodityCategoryList, "commodityCategory")}
                          {keyData.key === "commoditiesName" &&
                            renderDropdown(row, index, "commodityName", row.commodityNameList, "productName")}
                          {keyData.key === "commoditiesBrand" &&
                            renderDropdown(row, index, "brand", row.brandList, "brand")}
                          {keyData.key === "commoditiesQty" && renderQty(row, index)}
                          {keyData.key === "commoditiesUOM" && renderUom(row)}
                          {keyData.key === "charges" && renderCharges(row, index)}
                        </div>
                      )}
                    </div>
                  ))}
                </div>
              ))}
            </div>
          </div>
          <div className="md:hidden">
            {medicineCommodityError && (
              <div className="text-red-500">{medicineCommodityError}</div>
            )}
          </div>

          <div className={mainTable.submitCancelMainDiv}>
            <button
              data-modal-hide="bottom-right-modal"
              type="button"
              className={mainTable.submitButton}
              onClick={handleSubmit}
            >
              Submit
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default IssueOfCommodity;
